import React, { useState } from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import axios from "axios";
// import emailjs from 'emailjs-com';
import Notiflix from "notiflix";
import { Helmet } from "react-helmet-async";
import img from "../images/Web-developer.svg";

const Contact = () => {
  useDocTitle("TeqnoDux | Send us a message");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]);

  const clearErrors = () => {
    setErrors([]);
  };

  const clearInput = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setMessage("");
    setFile(null);
  };

  const validateFields = () => {
    const validationErrors = {};

    if (!firstName.trim()) {
      validationErrors.firstName = "First Name is required.";
    }

    if (!email.trim()) {
      validationErrors.email = "Email is required.";
    }

    if (!message.trim()) {
      validationErrors.message = "Message is required.";
    }

    return validationErrors;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    clearErrors();

    // Validate fields
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Disable the submit button
    document.getElementById("submitBtn").disabled = true;
    document.getElementById("submitBtn").innerHTML = "Sending...";

    const fData = new FormData();
    fData.append("first_name", firstName);
    fData.append("last_name", lastName);
    fData.append("email", email);
    fData.append("mobile", phone || "");
    fData.append("message", message);

    if (file) {
      fData.append("cv_file", file); // Add the file to FormData
    }

    axios({
      method: "post",
      url: `${process.env.REACT_APP_CONTACT_API}/api/contact-us`,
      data: fData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        document.getElementById("submitBtn").disabled = false;
        document.getElementById("submitBtn").innerHTML = "Send Message";
        clearInput();
        Notiflix.Report.success("Success", response.data.message, "Okay");
      })
      .catch((error) => {
        document.getElementById("submitBtn").disabled = false;
        document.getElementById("submitBtn").innerHTML = "Send Message";

        const { response } = error;

        if (response?.status === 500) {
          Notiflix.Report.failure(
            "An error occurred",
            response.data.message || "Internal Server Error",
            "Okay"
          );
        }
        if (response?.data?.errors) {
          setErrors(response.data.errors);
        }
      });
  };

  return (
    <>
      <Helmet>
        <title>TeqnoDux | Contact Us</title>
        <meta name="description" content="Contact Us" />
        <meta property="og:title" content="TeqnoDux | Contact Us" />
        <meta
          property="og:description"
          content="TeqnoDux specializes in innovative software development craftsmanship, delivering tailored solutions to empower your business."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="teqnoduxlogo.jpg" />
        <meta property="og:url" content="https://teqnodux.com/contact" />
        <meta property="og:site_name" content="TeqnoDux" />
        <link rel="canonical" href="https://teqnodux.com/contact" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "TeqnoDux",
            description:
              "TeqnoDux is a global leader in software development, delivering high-quality, custom software solutions tailored to your needs. Explore our innovative services!",
            provider: {
              "@type": "Organization",
              name: "TeqnoDux",
              url: "https://teqnodux.com/contact",
            },
            serviceType: [
              "Web Development",
              "Mobile App Development",
              "CRM Consulting",
              "3D Web Solutions",
            ],
            areaServed: "Worldwide",
            image: img,
            url: "https://teqnodux.com/contact",
          })}
        </script>
      </Helmet>
      <div>
        <NavBar />
      </div>
      <div
        id="contact"
        className="flex justify-center items-center mt-12 w-full bg-white py-12 lg:py-24 "
      >
        <div
          className="container mx-auto my-8 px-4 lg:px-20"
          data-aos="zoom-in"
        >
          <form onSubmit={sendEmail}>
            <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
              <div className="flex">
                <h1 className="font-bold text-center lg:text-left text-[#377c7d] uppercase text-[26px]">
                  Send us a message
                </h1>
              </div>
              <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                <div>
                  <input
                    name="first_name"
                    className={`w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline ${
                      errors.firstName ? "border-red-500" : ""
                    }`}
                    type="text"
                    placeholder="First Name*"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    onKeyUp={clearErrors}
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-sm">{errors.firstName}</p>
                  )}
                </div>

                <div>
                  <input
                    name="last_name"
                    className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    onKeyUp={clearErrors}
                  />
                </div>

                <div>
                  <input
                    name="email"
                    className={`w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline ${
                      errors.email ? "border-red-500" : ""
                    }`}
                    type="email"
                    placeholder="Email*"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyUp={clearErrors}
                  />
                  {errors && (
                    <p className="text-red-500 text-sm">{errors.email}</p>
                  )}
                </div>

                <div>
                  <input
                    name="phone_number"
                    className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                    type="number"
                    placeholder="Phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    onKeyUp={clearErrors}
                  />
                </div>
              </div>
              <div className="my-4">
                <textarea
                  name="message"
                  placeholder="Message*"
                  className={`w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline ${
                    errors.message ? "border-red-500" : ""
                  }`}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyUp={clearErrors}
                ></textarea>
                {errors && (
                  <p className="text-red-500 text-sm">{errors.message}</p>
                )}
              </div>

              <div className="my-4">
                <label
                  htmlFor="file-upload"
                  className="block text-gray-500 font-semibold text-lg mb-2"
                >
                  Upload PDF File
                </label>

                <div
                  className={`flex items-center justify-center w-full border-2 border-dashed rounded-xl p-6 cursor-pointer transition-all duration-300 
                    ${
                      errors.file
                        ? "border-red-400 bg-red-50"
                        : "border-gray-300 bg-gray-50 hover:bg-[#377c7d]/5 hover:border-gray-400"
                    }`}
                  onClick={() => document.getElementById("file-upload").click()}
                >
                  <div className="flex flex-col items-center space-y-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-10 w-10 text-[#6b7280]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M7 16V4m0 0l5 5m-5-5l-5 5m13 2h4m-4 4h4m-4 4h4"
                      />
                    </svg>
                    <p className="text-gray-600 font-normal text-base">
                      Click or drag PDF file to upload
                    </p>
                    {file && (
                      <p className="text-[#377c7d] font-medium text-sm">
                        Selected: {file.name}
                      </p>
                    )}
                  </div>
                </div>

                <input
                  id="file-upload"
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setFile(e.target.files[0])}
                  className="hidden"
                />

                {errors.file && (
                  <p className="text-red-500 text-sm mt-2">{errors.file}</p>
                )}
              </div>

              <div className="my-2 w-1/2 lg:w-2/4">
                <button
                  type="submit"
                  id="submitBtn"
                  className="uppercase text-sm font-bold tracking-wide bg-gray-500 hover:bg-[#377c7d] text-gray-100 p-3 rounded-lg w-full 
                                    focus:outline-none focus:shadow-outline"
                >
                  Send Message
                </button>
              </div>
            </div>
          </form>
          <div className="w-full  lg:-mt-96 lg:w-2/6 px-8 py-2 ml-auto bg-[#377c7d] rounded-2xl">
            <div className="flex flex-col text-white">
              <div className="flex my-4 w-2/3 lg:w-3/4">
                <div className="flex flex-col">
                  <i className="fas fa-map-marker-alt pt-2 pr-2" />
                </div>
                <div className="flex flex-col">
                  <h2 className="text-2xl font-sans">Office Address</h2>
                  <p className="text-[#E1E1E1]">
                    B - 705/706 IT Park, Mota varachha,
                    <br /> Surat, Gujarat, <br />
                    India- 394101
                  </p>
                </div>
              </div>

              <div className="flex my-2 w-2/3 lg:w-1/2">
                <div className="flex flex-col">
                  <i className="fas fa-phone-alt pt-2 pr-2" />
                </div>

                <div className="flex flex-col">
                  {/* <h2 className="text-2xl">Call Us</h2>
                  <p className="text-[#E1E1E1]">Tel: 8980888788</p> */}

                  <div className="mt-5">
                    <h2 className="text-2xl font-sans">E-mail</h2>
                    <p className="text-[#E1E1E1]">info@teqnodux.com</p>
                  </div>
                </div>
              </div>

              <div className="flex my-4 w-2/3 lg:w-1/2">
                <a
                  href="https://www.facebook.com/teqnoDux/"
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full flex justify-center bg-white h-8 text-blue-900  w-8  mx-1 text-center pt-1"
                  aria-label="Visit TeqnoDux on Facebook"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="fill-current font-black hover:animate-pulse"
                  >
                    <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path>
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/teqnodux/posts/?feedView=all"
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full flex justify-center bg-white h-8 text-blue-900  w-8  mx-1 text-center pt-1"
                  aria-label="Visit TeqnoDux on linkedin"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="fill-current font-black hover:animate-pulse"
                  >
                    <circle cx="4.983" cy="5.009" r="2.188"></circle>
                    <path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
